import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';

import AdvisoryPriceDisplay from '@stubhub/react-advisory-price-display';
import SmartSelect from '@stubhub/react-smart-select';
import {connect} from '@stubhub/react-store-provider';

import controller from './controller';

import './index.scss';

const TicketsQuantityPicker = ({
  price = {},
  toggleOnQtyPickClose,
  enableQuantityPicker,
  selectedQuantity,
  splitVector = [],
  isPriceLoading,
}) => {
  const intl = useIntl();
  const options = useMemo(
    () =>
      splitVector.map((qty) => ({
        value: qty.toString(),
        label: intl.formatMessage(
          {
            id: 'event-royal.react-build-your-order.ticketqty',
            defaultMessage: '{quantity} {quantity, plural, one {ticket} other {tickets}}',
          },
          {quantity: qty.toString()}
        ),
      })),
    [splitVector, intl]
  );

  return (
    <div className="RoyalBuildYourOrder__price__container">
      <div className="RoyalBuildYourOrder__price">
        <div className="RoyalBuildYourOrder__price__header">
          <FormattedMessage id="event-royal.react-build-your-order.priceHeader" defaultMessage="You'll pay" />
        </div>
        <div className="RoyalBuildYourOrder__price__display--actual">
          <div className="RoyalBuildYourOrder__price__display--actual__amount">
            <AdvisoryPriceDisplay price={price.amount} currency={price.currency} isLoading={isPriceLoading} />
            <div className="RoyalBuildYourOrder__price__display--actual__amount__each">
              <FormattedMessage id="BuildYourOrder.each" defaultMessage="each" />
            </div>
          </div>
        </div>
      </div>
      <SmartSelect
        className="RoyalBuildYourOrder__quantityPicker"
        onChange={toggleOnQtyPickClose}
        value={selectedQuantity?.toString() || ''}
        disabled={!enableQuantityPicker}
        labelText={intl.formatMessage({id: 'event-royal.react-dropdown.header', defaultMessage: 'Quantity'})}
        options={options}
      />
    </div>
  );
};

TicketsQuantityPicker.propTypes = {
  price: PropTypes.object,
  toggleOnQtyPickClose: PropTypes.func.isRequired,
  enableQuantityPicker: PropTypes.bool,
  selectedQuantity: PropTypes.number,
  splitVector: PropTypes.array,
  isPriceLoading: PropTypes.bool,
};

export default connect(controller)(TicketsQuantityPicker);
